import type { ReactNode } from "react";
import { usePermission } from "@/shared/hooks/usePermission";

interface PermissionGateProps {
	resource: string;
	action: string;
	children: ReactNode;
	/** Ruxsat bo'lmaganda ko'rsatiladigan narsa. Odatda hech narsa. */
	fallback?: ReactNode;
}

/**
 * Ruxsat bo'lmasa bolalarni ko'rsatmaydi.
 *
 * Bu faqat UI qulayligi — backend har so'rovda ruxsatni qaytadan tekshiradi.
 * Yashirilgan tugma himoya emas.
 */
export function PermissionGate({
	resource,
	action,
	children,
	fallback = null,
}: PermissionGateProps) {
	const { can } = usePermission();

	return <>{can(resource, action) ? children : fallback}</>;
}
